import { render, staticRenderFns } from "./CourseLeadersPage.vue?vue&type=template&id=a398d488&scoped=true&lang=pug&"
import script from "./CourseLeadersPage.vue?vue&type=script&lang=js&"
export * from "./CourseLeadersPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseLeadersPage.vue?vue&type=style&index=0&id=a398d488&lang=scss&scoped=true&"
import style1 from "./CourseLeadersPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a398d488",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
